"use client";
import AuthenticationPage from "@/components/auth/AuthenticationPage";
import { Suspense } from "react";

export default function Login() {
  return (
    <Suspense>
      <AuthenticationPage />
    </Suspense>
  );
}
